import styled from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router';

export const Title = styled.h1<{ marginTop?: number; marginBottom?: number }>`
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 500;
  font-size: ${rem(30)};
  line-height: ${rem(35)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom || marginBottom === 0 ? rem(marginBottom) : rem(56)};
  margin-top: ${({ marginTop }) =>
    marginTop || marginTop === 0 ? rem(marginTop) : rem(32)};

  ${({ theme }) => theme.mediab.l925`
    font-size: ${rem(24)};
    line-height: ${rem(28)};
    margin: 0;
    margin-top: ${({ marginTop }) =>
      marginTop || marginTop === 0 ? rem(marginTop) : rem(32)};
    margin-bottom: ${({ marginBottom }) =>
      marginBottom || marginBottom === 0 ? rem(marginBottom) : rem(32)};
  `}
`;

// vynulovane marginy
export const TitleMedium = styled.h3`
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 500;
  font-size: ${rem(30)};
  line-height: ${rem(39)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;

  ${({ theme }) => theme.mediab.l925`
    font-size: ${rem(24)};
    line-height: ${rem(31)};
    text-align: center;
  `}
`;

export const TitleLinkMedium = styled(Link)`
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 500;
  font-size: ${rem(24)};
  line-height: ${rem(31)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: none;
  }

  ${({ theme }) => theme.mediab.l925`
    font-size: ${rem(18)};
    line-height: ${rem(24)};
    margin-bottom: ${rem(16)};
  `}
`;

export const TextP = styled.p`
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 300;
  font-size: ${rem(16)};
  line-height: ${rem(24)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;

  ${({ theme }) => theme.mediab.l925`
    text-align: center;
    font-size: ${rem(14)};
    line-height: ${rem(21)};
  `}
`;

export const TextLink = styled(Link)`
  text-decoration: none;
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(21)};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 300;

  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;
